
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { UserPlus } from 'lucide-react';
import { AdminEmptyStateProps } from './types';

const AdminEmptyState = ({ filterActive, onAddAdmin }: AdminEmptyStateProps) => {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center p-8 text-center">
        <div className="rounded-full bg-primary/10 p-4 mb-4">
          <UserPlus size={40} className="text-primary" />
        </div>
        <h3 className="text-xl font-semibold mb-2">No administrators found</h3>
        {filterActive ? (
          <>
            <p className="text-muted-foreground mb-4">
              No administrators match your current filters. Try adjusting your search criteria.
            </p>
            <Button variant="outline">Clear Filters</Button>
          </>
        ) : (
          <>
            <p className="text-muted-foreground mb-4">
              You haven't added any administrators yet. Add your first administrator to get started.
            </p>
            <Button onClick={onAddAdmin}>
              <UserPlus className="h-4 w-4 mr-2" />
              Add Administrator
            </Button>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default AdminEmptyState;
